var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leftres"},[_c('div',[_c('div',{staticClass:"TableBox",staticStyle:{"box-shadow":"0px 1px 4px 0px rgba(0, 0, 0, 0.1)","background-color":"#FFFFFF"}},[_c('dataManagetable')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }